// `env` injected via webpack. Will break portal however, since this file is imported without the context of webpack. Thus, `try-catch`
let environment;
try {
  environment = {
    MMS_ORIGIN: env.MMS_ORIGIN || 'https://mms.sp-stage.net/mms/v2',
    CCPA_ORIGIN: env.CCPA_ORIGIN || 'https://ccpa.sp-stage.net',
    USNAT_ORIGIN: env.USNAT_ORIGIN || 'https://usp.sp-stage.net/usnat',
    USNAT_ORIGIN_BUILDER: env.USNAT_ORIGIN_BUILDER || 'https://usp.sp-stage.net/usnat',
    CMPV2_ORIGIN: env.CMPV2_ORIGIN || 'https://cmpv2.sp-stage.net/tcfv2',
    PREFERENCES_ORIGIN: env.PREFERENCES_ORIGIN || "https://cdn.sp-stage.net/preferences",
    PRODUCTION: env.PRODUCTION
  };
} catch (e) {
  environment = {
    PRODUCTION: true,
    MMS_ORIGIN: "https://cdn.privacy-mgmt.com/mms/v2",
    CCPA_ORIGIN: "https://ccpa-service.sp-prod.net",
    CMPV2_ORIGIN: "https://cdn.privacy-mgmt.com/consent/tcfv2",
    USNAT_ORIGIN: "https://cdn.privacy-mgmt.com/usnat",
    USNAT_ORIGIN_BUILDER: "https://prod-usp-bg-origin.sp-prod.net/usnat",
    PREFERENCES_ORIGIN: "https://cdn.privacy-mgmt.com/preferences"
  };
}
;
export const MMS_ORIGIN = environment.MMS_ORIGIN;
export const CCPA_ORIGIN = environment.CCPA_ORIGIN;
export const CMPV2_ORIGIN = environment.CMPV2_ORIGIN;
export const USNAT_ORIGIN = environment.USNAT_ORIGIN;
export const USNAT_ORIGIN_BUILDER = environment.USNAT_ORIGIN_BUILDER;
export const PREFERENCES_ORIGIN = environment.PREFERENCES_ORIGIN;
export const ccpaRoutes = {
  DELETE: 'delete-my-data',
  DSAR: 'dsar'
};
export const sarViews = {
  FORM: 'form',
  SUCCESS: 'success',
  error: {
    VERIFICATION: 'verification',
    MAX_REQUESTS: 'max-requests',
    ACTIVE_REQUEST: 'active-request'
  }
};
export const dsarRetrievalViews = {
  HOME: 'home',
  ONE_TIME_CODE: 'one-time-code',
  CODE_SUCCESS: 'code-success',
  REQUEST_PENDING: 'request-pending'
};
export const privacyManagerOTTViews = {
  HOME: 'home',
  CATEGORIES: 'categories',
  VENDORS: 'vendors',
  CARD_DETAILS: 'card_details',
  PRIVACY_POLICY: 'privacy_policy',
  CUSTOM_VIEW: 'custom_view'
};
export const privacyManagerOTTCCPAViews = {
  HOME: 'home',
  VENDORS: 'vendors',
  CATEGORIES: 'categories',
  PRIVACY_POLICY: 'privacy_policy',
  CARD_DETAILS: 'card_details',
  CUSTOM_VIEW: 'custom_view'
};
export const VERIFICATION_FAILURE = 'VERIFICATION_FAILURE';
export const MAX_REQUESTS_EXCEEDED = 'MAX_REQUESTS_EXCEEDED';
export const MISMATCH = 'MFA_CODE_FAILURE';
export const PROCESSING_REQUEST = 'PROCESSING_REQUEST';
export const lockedVendors = [];
export const inputNames = {
  FIRST_NAME: 'first-name',
  LAST_NAME: 'last-name',
  EMAIL: 'email',
  PHONE: 'phone',
  SSN: 'ssn',
  REQUEST_ID: 'request-id',
  MFA: 'mfa'
};
export const msgV2Origins = ['https://notice.sp-prod.net', 'https://notice.sp-stage.net'];
let isIE;
try {
  document.createElement('input').type = 'date';
  isIE = false;
} catch (e) {
  isIE = true;
}
;
export { isIE };
export const actionTypes = {
  SAVE_AND_EXIT: 1,
  REJECT_ALL: 13,
  ACCEPT_ALL: 11,
  CANCEL: 2,
  DISMISS: 15,
  SHOW_ATT_MSG: 16,
  99: 'CUSTOM_VIEW',
  100: 'HOME',
  ACCEPT_LI_ONLY: 1
};
export const mockPmData = {
  categories: [],
  specialPurposes: [],
  features: [],
  specialFeatures: [],
  vendors: []
};
export const nativePmViews = {
  HOME: 'HomeView',
  CATEGORIES: 'CategoriesView',
  VENDORS: 'VendorsView',
  PRIVACY_POLICY: 'PrivacyPolicyView',
  VENDOR_DETAILS: 'VendorDetailsView',
  CATEGORY_DETAILS: 'CategoryDetailsView',
  CUSTOM: 'CustomView'
};
export const SIGNATURE_PUBLIC_KEY = 'p7/rFOqX+iUCa+u60ELvX2bo5E+KZFe4KwT28iurjEA=';
export const portalOrigins = ['https://portal.sp-stage.net', 'https://preprod-portal.sourcepoint.com', 'https://portal.sourcepoint.com', 'https://gpp-portal.sp-stage.net'];
export const ALL_VENDORS_VAR = '$$!VC-ALL!$$';
export const IAB_VENDORS_VAR = '$$!VC-IAB!$$';
export const CHANNELS = {
  0: 'email',
  1: 'sms',
  2: 'whatsapp',
  3: 'phone',
  4: 'mail'
};